<template>
    <div class="avatar">
        <img class="avatar__img" :src="getAvatar(avatar)"/>
        <span class="avatar__label" :class="{ 'error' : !avatar || !avatar.id }" @click="this.$emit('showAvatarList')" v-html="avatar && avatar.id ? 'Zmień avatar' : 'Wybierz avatar'"></span>
    </div>
</template>

<script>
import { parseImageUrl } from '../../mixins/useParseImage';

export default {
    name: "ProfileNewAvatar",
    mixins: [parseImageUrl],
    props: {
        avatar: {
            type: Object
        }
    },
    methods: {
        getAvatar(img) {
            let url = '';
            if (img && img.url) {
                url = parseImageUrl(img.url,150,150);
            } else {
                return null;
            }
            return url;
        }
    }
};
</script>